import { lazy } from 'react';

import ROUTE_PATHS from 'cashout/config/routes/route-paths';
import { createBrowserHistory, History } from 'history';

export const history: History = createBrowserHistory();

const Routes = [
  {
    path: ROUTE_PATHS.preload,
    component: lazy(() => import('cashout/pages/preload-page')),
  },
  {
    path: ROUTE_PATHS.authentication,
    component: lazy(() => import('cashout/pages/authentication-page')),
  },
  {
    path: ROUTE_PATHS.beneficiary,
    component: lazy(() => import('cashout/pages/beneficiary-page')),
  },
  {
    path: ROUTE_PATHS.completed,
    component: lazy(() => import('cashout/pages/completed-page')),
  },
  {
    path: ROUTE_PATHS.profile,
    component: lazy(() => import('cashout/pages/profile-page')),
  },
  {
    path: ROUTE_PATHS.error,
    component: lazy(() => import('cashout/pages/error-page')),
  },
  {
    path: ROUTE_PATHS.identityValidation,
    component: lazy(() => import('cashout/pages/identity-validation-page')),
  },
];

export default Routes;
